<script>
import LayoutEditor from '@layouts/editor.vue'
import Canvas from '@components/Canvas/Canvas.vue'
import StepItems from '@components/menues/StepItems/StepItems.vue'
import PreviewModal from '@components/modals/PreviewModal/PreviewModal.vue'
import EditorTabsContainer from '@components/menues/EditorTabs/EditorTabsContainer.vue'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  page: {
    title: 'Editor',
    meta: [{ name: 'description', content: 'Editor' }],
  },
  name: 'EditorView',
  components: {
    LayoutEditor,
    'canvas-component': Canvas,
    'step-items-menu-component': StepItems,
    'preview-modal-component': PreviewModal,
    'editor-tabs-component': EditorTabsContainer,
  },
  data: function () {
    return {
      allowSave: true,
      showPreviewModal: false,
      campaignNotFound: false,
    }
  },
  computed: {
    ...mapGetters('campaign', ['targetCampaignWatermark']),
    ...mapGetters('campaign/widget', ['targetWidget']),
    ...mapState('campaign', ['isCampaignLoaded']),
  },
  created() {
    // use the param passed by the route
    this.getCampaign(this.$route.params.id).then((response) => {
      if (response === false) {
        this.campaignNotFound = true
      }
    })
    this.loadFonts()
  },
  beforeRouteLeave(to, from, next) {
    this.allowSave = false

    // Clear the campaign  widgets status
    this.$store.commit('campaign/CAMPAIGN_CLEAR')
    this.$store.commit('campaign/widget/WIDGETS_CLEAR')
    this.$store.commit('campaign/step/STEP_CLEAR')
    this.$store.commit('campaign/contentItem/CONTENT_ITEM_CLEAR')
    next()
  },
  methods: {
    ...mapActions('campaign', [
      'getCampaign',
      'createWidget',
      'clearCampaignStatus',
      'clearWidgetStatus',
    ]),
    ...mapActions('fonts', ['loadFonts']),
    ...mapActions('editor', ['saveGlobal']),
    navigateToSetup(campaignID) {
      this.saveGlobal().then(() => {
        this.$router.push({ path: `/setup-display/${campaignID}` })
      })
    },
  },
}
</script>

<template>
  <LayoutEditor>
    <div>
      <div v-if="campaignNotFound" :class="$style.campaignNotFound">
        <h1>Campaign not found</h1>
        <p>The campaign you have requested couldn't be found in our storage.</p>
      </div>
      <div v-if="isCampaignLoaded" id="editor-view">
        <transition name="fade">
          <preview-modal-component
              v-if="showPreviewModal"
              :show-preview-modal="showPreviewModal"
              :target-widget="targetWidget"
              :has-watermark="targetCampaignWatermark"
              @close="showPreviewModal = false"/>
        </transition>

        <el-container class="m-0">
          <el-aside width="185px">
            <step-items-menu-component/>
          </el-aside>

          <el-main :class="$style.elMain">
            <canvas-component/>
          </el-main>
          <el-aside :class="$style.elAside" width="25vw">
            <editor-tabs-component/>

            <div :class="$style.editorNav">
              <button class="mr-2 btn white outline big"
                      type="button"
                      @click="showPreviewModal = !showPreviewModal">
                <i class="el-icon-view mr-2"></i> Preview
              </button>

              <button class="-mr-5 btn primary big"
                      type="button"
                      @click="navigateToSetup($route.params.id)">
                Next <i class="el-icon-back rotate-180"></i>
              </button>
            </div>
          </el-aside>
        </el-container>
      </div>
    </div>
  </LayoutEditor>
</template>

<style lang="scss" module>
@import '@assets/sass/design/_sizes.scss';

.campaignNotFound {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  height: 100px;
  margin: auto;
  text-align: center;

  h1 {
    padding: 0;
    margin: 0;
  }

  p {
    font-weight: 300;
  }
}

.elMain {
  @apply bg-onvocado-white text-secondary;

  height: calc(100vh - #{$size-editor-header});
  padding: 0;
  margin: 0;
  line-height: 160px;
  text-align: center;
}

.elAside {
  min-width: 250px;
  max-width: 500px;
  height: calc(100vh - #{$size-editor-header});
  overflow-x: hidden;
  line-height: 200px;
}

.editorNav {
  position: fixed;
  top: 0;
  right: 40px;
  height: 70px;
  line-height: 70px;
}
</style>
